import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_choice_toggle = _resolveComponent("ontos-choice-toggle")!

  return (_ctx.offersComputed)
    ? (_openBlock(), _createBlock(_component_ontos_choice_toggle, {
        key: 0,
        "model-value": _ctx.computedMode,
        label: _ctx.labeled ? _ctx.filling.label : '',
        options: _ctx.computedOptions,
        disabled: !!_ctx.computeBlocked,
        "disabled-reason": _ctx.computeBlocked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.setComputed($event)))
      }, null, 8, ["model-value", "label", "options", "disabled", "disabled-reason"]))
    : _createCommentVNode("", true)
}